/**
 * Shows the time left before today's order cutoff, in the store's time zone.
 * Stays hidden outside dispatch days and after the cutoff.
 */
class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    this.update();
    this.timer = setInterval(() => this.update(), 30000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  update() {
    const [cutoffHour, cutoffMinute] = (this.dataset.cutoff || '14:0').split(':').map(Number);
    const [firstDay, lastDay] = (this.dataset.days || '1-5').split('-').map(Number);
    const now = this.storeTime();
    const minutesLeft = cutoffHour * 60 + cutoffMinute - (now.hour * 60 + now.minute);
    const isDispatchDay = now.weekday >= firstDay && now.weekday <= lastDay;
    const output = this.querySelector('[data-countdown-time]');

    if (!output || !isDispatchDay || minutesLeft <= 0) {
      this.hidden = true;
      return;
    }

    const hours = Math.floor(minutesLeft / 60);
    const minutes = minutesLeft % 60;
    output.textContent = hours ? `${hours}h ${minutes}m` : `${minutes}m`;
    this.hidden = false;
  }

  /** @returns {{weekday: number, hour: number, minute: number}} */
  storeTime() {
    const options = { weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' };
    let format;
    try {
      format = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: this.dataset.timeZone || 'Europe/London' });
    } catch {
      // An unrecognised time zone setting falls back to the shopper's clock.
      format = new Intl.DateTimeFormat('en-GB', options);
    }
    const parts = format.formatToParts(new Date());
    const value = (type) => parts.find((part) => part.type === type)?.value;
    return {
      weekday: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(value('weekday')),
      hour: Number(value('hour')),
      minute: Number(value('minute')),
    };
  }
}

if (!customElements.get('delivery-countdown')) customElements.define('delivery-countdown', DeliveryCountdown);
